<div class="grid grid-cols-1 lg:grid-cols-4 p-3 gap-y-3 lg:gap-3" lohiPageTitle="Driver Performance">
  <lohi-driver-tier-metric-detail [receivedData$]="selectedDriver$"></lohi-driver-tier-metric-detail>

  <div class="grid col-span-3 col-start-2 gap-y-3 lg:gap-3">
    <lohi-driver-tier-chart (chartSelected)="onChartSelected($event)"></lohi-driver-tier-chart>
    <lohi-driver-tier-metric-chart (secondChartSelected)="onChartSelected($event)"></lohi-driver-tier-metric-chart>
  </div>
</div>
